import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="container" style={{ display: 'grid', gap: '1.5rem', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', overflow: 'hidden' }}>
      <div>
        <h3 style={{ marginTop: 0 }}>Lawns Out West</h3>
        <p>Professional lawn mowing and garden services across Melbourne’s West.</p>
        <small>Phone: <a href="tel:0423358158">0423 358 158</a><br/>
        Email: <a href="mailto:lawnsoutwest@outlook.com">lawnsoutwest@outlook.com</a></small>
        <div style={{ marginTop: '0.75rem' }}>
          <a href="https://www.facebook.com/LawnsOutWest" target="_blank" rel="noreferrer">Facebook</a> ·{' '}
          <a href="https://www.instagram.com/lawnsoutwest" target="_blank" rel="noreferrer">Instagram</a>
        </div>
      </div>
      <div>
        <strong>Quick Links</strong>
        <ul style={{ listStyle: 'none', padding: 0, margin: '0.5rem 0' }}>
          <li><a href="#home">Home</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#gallery">Gallery</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>
      <div>
        <strong>Service Areas</strong>
        <p style={{ margin: '0.5rem 0' }}>Weir Views, Altona Meadows, Williamstown, Point Cook, Sunshine, Footscray & surrounds</p>
      </div>
    </div>
    <div className="container" style={{ marginTop: '1.25rem', borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: '0.75rem', overflow: 'hidden' }}>
      <small>© {new Date().getFullYear()} Lawns Out West. All rights reserved.</small>
    </div>
  </footer>
);

export default Footer;


